module['exports'] = {
  descriptor: [
    'سربراہ',
    'اعلیٰ',
    'مستقبل',
    'شہری',
    'ڈسٹرکٹ',
    'درمیانہ',
    'گلوبل',
    'گاہک',
    'بین ال اقوامی',
    'آگے',
    'اندرونی',
    'انسانی',
    'چیف',
    'پرنسپل',
  ],
  level: [
    'حل',
    'پروگرام',
    'برانڈ',
    'سکیورٹی',
    'ریسرچ',
    'آگاہی',
    'حربہ',
    'شناخت',
    'بازار',
    'گروہ',
    'تقسیم',
    'استعمال',
    'بات چیت',
    'جال',
  ],
};
